import { createFileRoute, retainSearchParams } from "@tanstack/react-router"
import { z } from "zod"

import { PriceChangeType } from "@/graphql/codegen/graphql"
import PriceChangeContainer from "@/screens/Pricing/containers/PriceChangeContainer"
import { useUnitOfMeasurementsStore } from "@/stores/unitOfMeasurmentsStore"

const SearchParamsValidator = z.object({
  changeType: z.nativeEnum(PriceChangeType).optional(),
  supplierId: z.string().optional(),
  customerIds: z.array(z.string()).optional(),
  productCategoryId: z.string().optional(),
  productClassId: z.string().optional(),
  specificProductIds: z.array(z.string()).optional(),
  shipFrom: z.string().optional(),
  shipTo: z.string().optional(),
  effectiveDate: z.string().optional(),
})

export const Route = createFileRoute("/app/pricing/_layout/price-change")({
  component: () => (
    // <PermissionContentWrapper
    //   permissions={[
    //     PermissionActionType.PRICING_VIEW,
    //     PermissionActionType.PRICING_MANAGER,
    //     PermissionActionType.PRICING_MAINTENANCE,
    //   ]}
    // >
    <PriceChangeContainer />
    // </PermissionContentWrapper>
  ),
  validateSearch: SearchParamsValidator,
  search: {
    middlewares: [retainSearchParams(SearchParamsValidator.keyof().options)],
  },
  loader: async (): Promise<void> => {
    await useUnitOfMeasurementsStore.getState().getUnits()
  },
})
